import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import moment from 'moment'
import 'moment/locale/es'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/es'

import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import {WithChildren} from '../helpers'

const allMessages = {
  en: enMessages,
  es: esMessages,
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  // Keep moment's global locale in sync with the app language so dates
  // (month/day names) render translated everywhere. Set before children render.
  moment.locale(locale)

  return (
    <IntlProvider
      locale={locale}
      defaultLocale='en'
      messages={messages}
      onError={(err) => {
        // Silence missing-translation noise while the migration is in progress.
        if (err.code === 'MISSING_TRANSLATION') return
        console.error(err)
      }}
    >
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
